export const SIGN_IN: string = "SIGN_IN";
export const SIGN_OUT: string = "SIGN_OUT";
export const SSO_SIGN_IN: string = "SSO_SIGN_IN";
export const SSO_SIGN_OUT: string = "SSO_SIGN_OUT";
export const USER_LOGIN: string = "USER_LOGIN";
export const IS_AUTHENTICATED: string = "IS_AUTHENTICATED";
export const GET_SCHOOL_INFO: string = "GET_SCHOOL_INFO";
export const FETCH_SCHOOL_ISIR_REC_INFO: string = "FETCH_SCHOOL_ISIR_REC_INFO";
export const UPDATE_AID_YEAR: string = "UPDATE_AID_YEAR";
export const SET_DEFAULT_AID_YEAR: string = "SET_DEFAULT_AID_YEAR";
export const FETCH_AVAILABLE_AID_YEARS: string = "FETCH_AVAILABLE_AID_YEARS";
export const ADD_ERROR_ALERT: string = "ADD_ERROR_ALERT";
export const REMOVE_ERROR_ALERT: string = "REMOVE_ERROR_ALERT";
export const ADD_SUCCESS_ALERT: string = "ADD_SUCCESS_ALERT";
export const REMOVE_SUCCESS_ALERT: string = "REMOVE_SUCCESS_ALERT";
export const ADD_MESSAGE_ALERT: string = "ADD_MESSAGE_ALERT";
export const REMOVE_MESSAGE_ALERT: string = "REMOVE_MESSAGE_ALERT";
export const ADD_WARNING_ALERT: string = "ADD_WARNING_ALERT";
export const REMOVE_WARNING_ALERT: string = "REMOVE_WARNING_ALERT";
export const FETCH_STUDENT: string = "FETCH_STUDENT";
export const FETCH_PARENT: string = "FETCH_PARENT";
export const FETCH_STUDENT_ATTRIBUTES: string = "FETCH_STUDENT_ATTRIBUTES";
export const SET_STUDENT_ACCOUNTS: string = "SET_STUDENT_ACCOUNTS";
export const RESET_STUDENT: string = "RESET_STUDENT";
export const FETCH_CORRECTION_SUMMARIES: string = "FETCH_CORRECTION_SUMMARIES";
export const FETCH_BIO_INFO: string = "FETCH_BIO_INFO";
export const FETCH_STUDENT_PARAMETERS: string = "FETCH_STUDENT_PARAMETERS";
export const FETCH_INTERVIEW_LINKS: string = "FETCH_INTERVIEW_LINKS";
export const FETCH_INTERVIEW_LINKS_ALL: string = "FETCH_INTERVIEW_LINKS_ALL";
export const FETCH_INTERVIEW_LINKS_HISTORY: string = "FETCH_INTERVIEW_LINKS_HISTORY";
export const FETCH_STUDENT_ALERTS: string = "FETCH_STUDENT_ALERTS";
export const FETCH_STUDENT_MEMOS: string = "FETCH_STUDENT_MEMOS";
export const FETCH_SCHOOL: string = "FETCH_SCHOOL";
export const FETCH_SCHOOL_LOGO: string = "FETCH_SCHOOL_LOGO";
export const RESET_SCHOOL: string = "RESET_SCHOOL";
export const RESET_GLOBAL: string = "RESET_GLOBAL";
export const FETCH_SIGNATURE_ALLOWANCE: string = "FETCH_SIGNATURE_ALLOWANCE";
export const RESET_SIGNATURE_ALLOWANCE: string = "RESET_SIGNATURE_ALLOWANCE";
export const FETCH_INTERVIEW_TYPES_ALL: string = "FETCH_INTERVIEW_TYPES_ALL";
export const FETCH_STUDENT_PROCESSOR_DOCUMENTS: string = "FETCH_STUDENT_PROCESSOR_DOCUMENTS";
export const FETCH_PERMISSIONS: string = "FETCH_PERMISSIONS";
export const FETCH_ROLES: string = "FETCH_ROLES";
export const FETCH_ROLE_PERMISSION_LINKS: string = "FETCH_ROLE_PERMISSION_LINKS";
export const ADD_ROLE_PERMISSION_LINK: string = "ADD_ROLE_PERMISSION_LINK";
export const REMOVE_ROLE_PERMISSION_LINK: string = "REMOVE_ROLE_PERMISSION_LINK";
export const FETCH_ACTIVE_PERMISSIONS: string = "FETCH_ACTIVE_PERMISSIONS";
export const RESET_PERMISSIONS: string = "RESET_PERMISSIONS";
export const FETCH_NESTED_CATEGORIES: string = "FETCH_NESTED_CATEGORIES";
export const UPDATE_IS_CROSS_SCHOOL_SEARCH: string = "UPDATE_IS_CROSS_SCHOOL_SEARCH";
export const UPDATE_CROSS_SCHOOL_SEARCH_VALUE: string = "UPDATE_CROSS_SCHOOL_SEARCH_VALUE";
export const UPDATE_CROSS_SCHOOL_SEARCH_FIELD: string = "UPDATE_CROSS_SCHOOL_SEARCH_FIELD";
// If passing true, this will perform a search immidiately, then the value will be set to false again until the search button is clicked again
export const UPDATE_CROSS_SCHOOL_SEARCH_DO_SEARCH: string = "UPDATE_CROSS_SCHOOL_SEARCH_DO_SEARCH";
export const UPDATE_CROSS_SCHOOL_SEARCH_CLEAR_SEARCH: string = "UPDATE_CROSS_SCHOOL_SEARCH_CLEAR_SEARCH";
export const UPDATE_SSO_USER_SCHOOLCODE: string = "UPDATE_SSO_USER_SCHOOLCODE";
export const FETCH_COMMENT_CODE_INFOS: string = "FETCH_COMMENT_CODE_INFOS";
export const FETCH_COMMENT_CODE_LINKS: string = "FETCH_COMMENT_CODE_LINKS";
export const UPDATE_ACTIVE_INTERVIEW_LINK: string = "UPDATE_ACTIVE_INTERVIEW_LINK";
// Admin types
export const FETCH_ISIR_REC_ELEMENT_INFO: string = "FETCH_ISIR_REC_ELEMENT_INFO";
// Toggle types
export const FETCH_TOGGLE: string = "FETCH_TOGGLE";
export const RESET_TOGGLES: string = "RESET_TOGGLES";